<!-- Hero card: color swatch + editable hex (left), identity (right). -->
<div class="cp-hero">
  <!-- Left: a square color swatch (click to open the native picker) with the
       editable hex centered below it. -->
  <div class="cp-hero-color-col">
    <div class="cp-hero-square" [style.background-color]="current">
      <input type="color" [ngModel]="current" (ngModelChange)="onColorChange( $event )"
             class="cp-hero-picker" aria-label="Pick a color"/>
      <span class="cp-hero-pick-hint" aria-hidden="true">Select</span>
    </div>
    <div class="cp-hero-hexbar">
      <!-- Same notation-title-above-the-input language as the converter heroes. -->
      <span class="cp-hero-input-title">Color</span>
      <label class="hex-field">
        <span class="hex-hash">#</span>
        <input type="text" class="hex-input"
               [ngModel]="hexText"
               (ngModelChange)="onHexTextChange( $event )"
               (keydown)="onHexKeydown( $event )"
               (keydown.enter)="onHexEnter( $event )"
               (focus)="onHexFocus( $event )"
               (blur)="hexText = current.substring( 1 ).toLowerCase()"
               maxlength="6"
               inputmode="latin"
               spellcheck="false"
               autocomplete="off"
               autocapitalize="off"
               aria-label="Hex color code"/>
      </label>
    </div>
  </div>

  <!-- Right: identity. Fixed footprint so it never shifts as values change. -->
  <div class="cp-hero-id">
    <h2 class="cp-name">{{ formattedColorName ? formattedColorName : ( current | uppercase ) }}</h2>
    <p class="cp-lead">
      A {{ hsl.l < 32 ? 'dark' : ( hsl.l > 70 ? 'light' : 'medium' ) }},
      {{ temperature }} color at {{ hsl.h }}&deg; hue
    </p>

    <!-- A label/value/copy grid. Deliberately NOT a <dl>: each row also holds a
         Copy button, and the axe "definition-list" rule (Lighthouse agentic
         accessibility) requires a <dl>'s row groups to contain only <dt>/<dd>,
         so a button sibling made the accessibility tree "not well-formed".
         Plain div/span rows render identically (the grid is by child order)
         and carry no structural-validity rule. -->
    <div class="cp-id-list">
      <div class="cp-id-row">
        <span class="cp-id-term">Hex</span>
        <span class="cp-id-value">{{ current | uppercase }}</span>
        <button type="button" class="cp-id-copy" (click)="copy( current.toUpperCase(), 'id-hex' )" aria-label="Copy hex">
          <app-icon name="copy" aria-hidden="true"></app-icon>{{ copiedKey === 'id-hex' ? 'Copied' : 'Copy' }}
        </button>
      </div>
      <div class="cp-id-row">
        <span class="cp-id-term">RGB</span>
        <span class="cp-id-value">{{ rgbString }}</span>
        <button type="button" class="cp-id-copy" (click)="copy( rgbString, 'id-rgb' )" aria-label="Copy RGB">
          <app-icon name="copy" aria-hidden="true"></app-icon>{{ copiedKey === 'id-rgb' ? 'Copied' : 'Copy' }}
        </button>
      </div>
      <div class="cp-id-row">
        <span class="cp-id-term">HSL</span>
        <span class="cp-id-value">{{ hslString }}</span>
        <button type="button" class="cp-id-copy" (click)="copy( hslString, 'id-hsl' )" aria-label="Copy HSL">
          <app-icon name="copy" aria-hidden="true"></app-icon>{{ copiedKey === 'id-hsl' ? 'Copied' : 'Copy' }}
        </button>
      </div>
      <div class="cp-id-row">
        <span class="cp-id-term">Web Safe</span>
        <span class="cp-id-value">{{ webSafe | uppercase }}</span>
        <button type="button" class="cp-id-copy" (click)="copy( webSafe.toUpperCase(), 'id-websafe' )" aria-label="Copy web-safe hex">
          <app-icon name="copy" aria-hidden="true"></app-icon>{{ copiedKey === 'id-websafe' ? 'Copied' : 'Copy' }}
        </button>
      </div>
      <div class="cp-id-row" *ngFor="let row of moreRows">
        <span class="cp-id-term">{{ row.label }}</span>
        <span class="cp-id-value">{{ row.value }}</span>
        <button type="button" class="cp-id-copy" (click)="copy( row.value, row.key )" [attr.aria-label]="'Copy ' + row.label">
          <app-icon name="copy" aria-hidden="true"></app-icon>{{ copiedKey === row.key ? 'Copied' : 'Copy' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Home page: a read-more style CTA linking to the full colour tool. -->
<div *ngIf="showDetailsCta" class="cw-cta-row">
  <a class="codigrate-button" [routerLink]="detailsRoute">
    <app-arrow-right [height]="16"></app-arrow-right>
    <p>Open Color Explorer</p>
  </a>
</div>
